import { useContext } from 'react'

import { PagesContext, type PagesContextState } from 'modules/pages/lib/context/PagesContext'

export const usePagesContext = (): PagesContextState => {
  const context = useContext(PagesContext)

  if (context === undefined) {
    throw new Error('usePagesContext must be used within a PagesContextProvider')
  }

  return context
}
